import { defineComponent, h } from 'vue';
import { QBtn, QIcon, QTooltip } from 'quasar';
import BaseComponent from './BaseButtonMixin.jsx';
import '../css/BasicButton.css';

/** Hardcoded until BasicButton schema exposes code-behind metadata. */
const BASIC_BUTTON_CLICK_CODE_BEHIND = {
    handlerSuffix: '_Click',
    actionTypeSchema: '/schema/public/Platform.Schema.UIActions.v1/UIAction_Script',
    buildScopeMethodTemplate(methodName) {
        return `\t${methodName}(context) {\n\t\t// Place your click handler here\n\t}`;
    },
};

export default defineComponent({
    name: 'BasicButton',
    mixins: [BaseComponent],
    components: { QBtn, QIcon, QTooltip },
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
    },
    methods: {
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
        handleDesignerDblClick(e) {
            e.stopPropagation();
            e.preventDefault();
            this.Root?.openCodeBehind?.(this, BASIC_BUTTON_CLICK_CODE_BEHIND);
        },
    },
    props: {
    },
    render() {
        let button = (
            <QBtn
                class={[this.buttonClasses, this.sentenceCaseButtonClasses]}
                style={this.buttonStyles}
                color={this.color}
                align={this.align}
                fab={this.buttonFab}
                round={this.buttonFab}
                flat={this.qBtnFlat}
                outline={this.qBtnOutline}
                size={this.size}
                dense={this.density}
                disable={this.isdisabled}
                noCaps
            >
                {this.getButtonContent()}
                {this.renderButtonTooltip()}
            </QBtn>
        );

        return (
            <div
                class={[
                    'q-ma-xs',
                    {
                        'designer-container': true,
                        'c-BasicButton': true,
                        'c-useLiteralCasing': this.useLiteralCasing,
                    },
                ]}
                style={this.sizeStyle}
                onClick={(e) => this.handleClick(e)}
                onDblclick={(e) => this.handleDesignerDblClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                {button}
            </div>
        );
    }
});
